<template>
  <v-app>
    <div :class="{ greenBg: auth.status }"></div>
    <div :class="{ greyBg: auth.status }"></div>
    <appbar />
    <drawer />
    <v-main style="z-index: 2; position: relative">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>
    <snackbar />
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import appbar from '@/components/navbars/appbar'
import drawer from '@/components/navbars/drawer'
import snackbar from '@/components/widgets/snackbar'

export default {
  name: 'App',
  components: { appbar, drawer, snackbar },
  computed: { ...mapState(['auth']) },
  methods: {
    ...mapActions(['initTicketingSystem', 'verifyToken'])
  },
  async mounted() {
    // The STORE action, not a second copy of the request. This used to call `this.$api.verifyToken`
    // inline and guard nothing: a mount-time check that answered after the operator had logged in
    // as someone else reset the NEW session and bounced them to `/`. The action captures the
    // session identity, so a stale answer now writes nothing — and it owns the expired-token path
    // (`/login`, which is where the heartbeat has always sent people).
    if (this.auth.status && (await this.verifyToken())) this.initTicketingSystem()

    setInterval(() => {
      if (this.auth.status) this.verifyToken()
    }, 10000)
  }
}
</script>

<style scoped>
.greenBg {
  position: fixed !important;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 50vh !important;
  z-index: 1 !important;
  background: rgb(206, 45, 45) !important;
  background: linear-gradient(126deg, #2ccf8c, #2fcfc7 96%) !important;
}

.greyBg {
  position: absolute;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 0 !important;
  background: #f5f5f5;
}
</style>

<style>
* {
  font-family: PingFangHK-Semibold, sans-serif;
}

/* width */
/* ::-webkit-scrollbar {
  width: 5px;
} */

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(187, 187, 187);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
